import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgInfo({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12C23.993 5.376 18.624.007 12 0Zm.25 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM10.5 18.5h4a1 1 0 1 0 0-2h-.75a.25.25 0 0 1-.25-.25V11.5a2 2 0 0 0-2-2h-1a1 1 0 1 0 0 2h.75a.25.25 0 0 1 .25.25v4.5a.25.25 0 0 1-.25.25h-.75a1 1 0 1 0 0 2Z"
                fill="currentColor"
            />
        </svg>
    )
}
SvgInfo.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgInfo
